module.exports = __webpack_public_path__ + "media/images/grid_image-10-9981aefcbe54af899e142922715eca31.jpg";